import "./styles/DisplayExams.css";
import ExamCard from "./ExamCard";
import ExamCardLoader from "./SkeletonLoaders/ExamCardLoader";
import NoItemsDisplay from "../Custom/NoItemsDisplay";
import { AutoStoriesRounded, ManageSearchRounded } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const Loader = () => {
  return (
    <div className="around-exams">
      <div className="exams-container">
        <ExamCardLoader />
        <ExamCardLoader />
        <ExamCardLoader />
        <ExamCardLoader />
      </div>
    </div>
  );
};

const DisplayExams = (props) => {
  const [searchParams] = useSearchParams();
  const [noItemsProps, setNoItemsProps] = useState({
    icon: <AutoStoriesRounded color="iconGray" className="no-items-icon" />,
    textItems: [
      "You have not created any exams yet.",
      "Click the add exam button to get started.",
    ],
  });

  useEffect(() => {
    if (searchParams.get("search")) {
      setNoItemsProps({
        icon: (
          <ManageSearchRounded color="iconGray" className="no-items-icon" />
        ),
        textItems: ["No exams were found"],
      });
    } else {
      setNoItemsProps((prev) => ({
        ...prev,
      }));
    }
  }, [searchParams]);

  if (props.loading) {
    return <Loader />;
  }

  if ((!props.exams || props.exams.length === 0) && !props.loading) {
    return (
      <NoItemsDisplay
        children={noItemsProps.icon}
        textItems={noItemsProps.textItems}
      />
    );
  }
  return (
    <>
      <div className="around-exams">
        <div className="exams-container">
          {props.exams?.map((exam, index) => {
            return (
              <div key={exam.id}>
                <ExamCard
                  exam={exam}
                  getExams={props.getExams}
                  token={props.token}
                  user={props.user}
                  index={index}
                />
              </div>
            );
          })}
        </div>
      </div>{" "}
    </>
  );
};

export default DisplayExams;
